import Api from '@/services/Api'

export default {
  //// GET
  // User routes
  checkToken: () => Api().get('user/token'),
  getUserGeneral: (id) => Api().get('user/general/' + id),
  getUserInfo: (id) => Api().get('user/info/' + id),
  getEvents: (id) => Api().get('/events/get-events/' + id),
  getEventDetail: (id, event_id) => Api().get('/events/get-event-detail/' + event_id),
  getChats: (id) => Api().get('/chats/get-chats/' + chat_id),
  getAllServices: () => Api().get('/services/service-list'),
  getAllServiceFilters: () => Api().get('/services/service-filters'),

  // Admin routes
  getBetaUsers: () => Api().get('admin/beta'),
  getAllUsers: () => Api().get('admin/all-users'),
  getAllUserEvents: () => Api().get('admin/all-events'),

  //// POST
  // User routes
  loginUser: (params) => Api().post('user/login', params),
  createUser: (params) => Api().post('user/create', params),
  createEvent: (params) => Api().post('events/create', params),
  createEventRequest: (params) => Api().post('/events/add-request', params),
  createChat: (params) => Api().post('/chats/create', params),
  toggleEventItemStatus: (params) => Api().post('/events/toggle-event-item-status', params),
  setUserGeneral: (params) => Api().post('user/general', params),

  // Admin Routes
  addBetaUser: (params) => Api().post('admin/beta', params),

  //// Delete
  // User Routes

  // Admin Routes
  deleteBetaUser: (phone) => Api().delete('admin/beta/' + phone)
}